import { mutationOptions } from "@/common/mutations/mutationOptions";
import type { updateMFAPreference } from "aws-amplify/auth";
import type { QueryClient } from "@tanstack/react-query";

export function updateUserMFAPreferenceMutationOptions(
	queryClient: QueryClient,
	updateMFAPreferenceFn: typeof updateMFAPreference,
) {
	return mutationOptions({
		mutationKey: ["setUserMFAPreference"],
		mutationFn: updateMFAPreferenceFn,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["userMFAStatus"],
			});
		},
	});
}
